export const sortClassTimes = (classTimes: string): string[] => {
    const classTimesArray: string[] = classTimes.split(',');

    classTimesArray.sort((a, b) => {
        const startTimeA = parseInt(a.split(':')[0], 10);
        const startTimeB = parseInt(b.split(':')[0], 10);

        return startTimeA - startTimeB;
    });

    return classTimesArray;
};
